import * as types from '../const/action.types';
import { loadBasicInfo } from './session.actions';

import { get, post, put } from '../api/_basic';

export function loadUsers(rol, local) {
    return async (dispatch) => {
        dispatch(usersHasErrored(false, ''));
        dispatch(usersIsLoading(true));
        try {
            const url = rol
                ? `${process.env.REACT_APP_API_USER}/porrol/${rol}`
                : local
                ? `${process.env.REACT_APP_API_USER}/porlocal/${local}`
                : `${process.env.REACT_APP_API_USER}`;

            const aux =
                rol && local
                    ? await get(`${process.env.REACT_APP_API_USER}/porlocal/${local}`)
                    : undefined;

            get(url)
                .then((info) => {
                    dispatch(usersIsLoading(false));
                    if (info.error !== undefined) {
                        throw Error(info);
                    }
                    if (aux) {
                        const ids = aux.map((i) => i.id);
                        return info.reduce((arr, c) => {
                            if (ids.indexOf(c.id) >= 0) {
                                arr.push(c);
                            }
                            return arr;
                        }, []);
                    } else {
                        return info;
                    }
                })
                .then((items) => {
                    dispatch(usersHasErrored(false, ''));
                    dispatch(loadUsersSuccess(items));
                })
                .catch((error) => {
                    dispatch(usersIsLoading(false));
                    dispatch(usersHasErrored(error.type ? error.type : true, error.message));
                });
        } catch (error) {
            dispatch(usersIsLoading(false));
            dispatch(usersHasErrored(error.type ? error.type : true, error.message));
        }
    };
}

export function addUser(user) {
    return async (dispatch) => {
        dispatch(userIsSaving(true));
        try {
            return post(`${process.env.REACT_APP_API_USER}`, user)
                .then((response) => {
                    if (response.error !== undefined) {
                        throw Error(response);
                    }
                    dispatch(userIsSaving(false));
                    dispatch(loadBasicInfo());
                    return true;
                })
                .catch((error) => {
                    dispatch(userIsSaving(false));
                    dispatch(usersHasErrored(error.type ? error.type : true, error.message));
                });
        } catch (error) {
            console.log(error);
            throw error;
        }
    };
}

export function editUser(user) {
    return async (dispatch) => {
        dispatch(userIsSaving(true));
        try {
            return put(`${process.env.REACT_APP_API_USER}/${user.login}`, user)
                .then((response) => {
                    if (response.error !== undefined) {
                        throw Error(response);
                    }
                    dispatch(userIsSaving(false));
                    dispatch(loadBasicInfo());
                    return true;
                })
                .catch((error) => {
                    dispatch(userIsSaving(false));
                    dispatch(usersHasErrored(error.type ? error.type : true, error.message));
                });
        } catch (error) {
            console.log(error);
            throw error;
        }
    };
}

export function changePin(user, newpassword) {
    return async (dispatch) => {
        return put(`${process.env.REACT_APP_API_USER}/${user}`, { password: newpassword })
            .then((response) => {
                if (response.error !== undefined) {
                    throw Error(response);
                }
                return true;
            })
            .catch((error) => {
                console.log(error);
                throw error;
            });
    };
}

export function loadInfo(user) {
    return async (dispatch) => {
        dispatch(usersHasErrored(false, ''));
        dispatch(usersIsLoading(true));
        console.log('load Use', user);
        try {
            const response = await get(`${process.env.REACT_APP_API_USER}/${user}`);

            if (response.error !== undefined) {
                throw Error(response);
            }
            console.log(response);
            const info = response;
            if (info.idCliente) {
                info.cliente = await get(`${process.env.REACT_APP_API_CLIENT}/${info.idCliente}`);
            }
            info.roles = await get(`${process.env.REACT_APP_API_ROLES}`);
            if (info.permisos && info.permisos.length > 0) {
                const temp = info.permisos.reduce((arr, p) => {
                    if (arr[p.idlocal]) {
                        arr[p.idlocal].idrol.push(p.idrol);
                        arr[p.idlocal].rol.push(info.roles.find((f) => f && f.id === p.idrol));
                    } else {
                        arr[p.idlocal] = {
                            idlocal: p.idlocal,
                            idusuario: p.idusuario,
                            idrol: [p.idrol],
                            rol: [info.roles.find((f_1) => f_1 && f_1.id === p.idrol)],
                        };
                    }
                    return arr;
                }, []);

                info.permisos = Object.keys(temp).map(function(i) {
                    return temp[i];
                });
            }
            console.log(info);
            dispatch(usersIsLoading(false));
            dispatch(usersHasErrored(false, ''));
            dispatch(loadUserSuccess(info));
        } catch (error) {
            dispatch(usersIsLoading(false));
            dispatch(usersHasErrored(error.type ? error.type : true, error.message));
        }
    };
}

export function loadUserSuccess(data) {
    return {
        type: types.LOAD_USER_SUCCESS,
        data,
    };
}

export function loadUsersSuccess(data) {
    return {
        type: types.USERS_SUCCESS,
        data,
    };
}

export function usersHasErrored(bool, message) {
    return {
        type: types.USER_HAS_ERROR,
        hasErrored: bool,
        error: message,
    };
}

export function usersIsLoading(bool) {
    return {
        type: types.USERS_IS_LOADING,
        isLoading: bool,
    };
}

export function userIsSaving(bool) {
    return {
        type: types.USERS_IS_SAVING,
        isLoading: bool,
    };
}



// WEBPACK FOOTER //
// ./src/actions/user.actions.js